module.exports = "/subscriptions/assets/99ec20c1043b481e569fe21faca10d82.svg";